import { render, staticRenderFns } from "./woodfish.vue?vue&type=template&id=5f8a8d3c&scoped=true&"
import script from "./woodfish.vue?vue&type=script&lang=js&"
export * from "./woodfish.vue?vue&type=script&lang=js&"
import style0 from "./woodfish.vue?vue&type=style&index=0&id=5f8a8d3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8a8d3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f8a8d3c')) {
      api.createRecord('5f8a8d3c', component.options)
    } else {
      api.reload('5f8a8d3c', component.options)
    }
    module.hot.accept("./woodfish.vue?vue&type=template&id=5f8a8d3c&scoped=true&", function () {
      api.rerender('5f8a8d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/god/woodfish.vue"
export default component.exports